import axios from 'axios';

export const axiosApiInstance = axios.create();

export const headers = {
  'content-type': 'application/json;charset=UTF-8',
  'X-API-Key': 'EDI2021TEST!',
  // Authorization: sessionStorage.getItem('TOKEN'),
};

export const download_headers = {
  'content-type': 'application/json;charset=UTF-8',
  'X-API-Key': 'EDI2021TEST!',
  Authorization: sessionStorage.getItem('TOKEN'),
};

export const multipart_headers = {
  'content-type': 'multipart/form-data',
  'X-API-Key': 'EDI2021TEST!',
  Authorization: sessionStorage.getItem('TOKEN'),
};

export const intro_headers = {
  'content-type': 'application/json;charset=UTF-8',
  'X-API-Key': 'EDI2021TEST!',
  // Authorization: sessionStorage.getItem('TOKEN'),
};

// Token 영향 받지 않는 path 설정
// const freePath = ['/intro', '/login', '/sign'];

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      config.headers.Authorization = sessionStorage.getItem('TOKEN');
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
